import axios from "axios";
import catchAsync from "../utils/catchAsync";

// const baseURL = "https://api-dev.lookfindrdev.com/api/v1";
const baseURL = process.env.REACT_APP_BASE_URL;
const clientURL = baseURL + "client";
const axiosInstance = axios.create();
axiosInstance.interceptors.request.use((config) => {
  config.headers["accept-language"] =
    localStorage.getItem("currentLang") || "ar";

  return config;
});
export const salonLocationBySlug = catchAsync(
  (slug: string, params?: object) => {
    return axiosInstance.get(`${clientURL}/locations/${slug}/link`, {
      params,
    });
  }
);

export const clientRegister = catchAsync((data: object) => {
  return axiosInstance.post(`${clientURL}/register`, data);
});
export const clientAuthReSendOtp = catchAsync(
  async (body: { phone: string }) => {
    return axiosInstance.post(`${clientURL}/resend-otp-code`, body);
  }
);

export const clientAuthVerifyOtp = catchAsync(
  async (body: { phone: string; phone_country_code: string; code: string }) => {
    return await axiosInstance.post(`${clientURL}/otp-verification`, body);
  }
);

export const clientLogin = async (body: object) => {
  return await axiosInstance.post(`${baseURL}login`, body);
};

export const clientGetAvailableTeamMembers = catchAsync(
  async (
    locationId: number,
    token: string,
    body: { date: string; pricing_option_ids: number[] }
  ) => {
    return await axiosInstance.post(
      `${clientURL?.replace(
        "v1",
        "v2"
      )}/${locationId}/appointments/available-team-members`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
);

export const clientGetAvailableTimeSlots = catchAsync(
  async (
    locationId: number,
    token: string,
    body: { date: string; pricing_option_ids: number[]; team_member_id: number }
  ) => {
    return await axiosInstance.post(
      `${clientURL?.replace(
        "v1",
        "v2"
      )}/${locationId}/appointments/available-time-slots`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
);

export const clientCreateAppointment = catchAsync(
  async (locationId: number, token: string, body: any) => {
    return await axiosInstance.post(
      `${clientURL?.replace("v1", "v2")}/${locationId}/appointments`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
);

export const clientValidatePromoCode = catchAsync(
  async (locationId: number, token: string, params: object) => {
    return await axiosInstance.get(`${clientURL}/${locationId}/promo-codes`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
  }
);

export const clientSendOTP = catchAsync(async (body: any) => {
  return await axiosInstance.post(`${baseURL}send`, body);
});

export const clientVerifyLoginOTP = catchAsync(async (body: any) => {
  return await axiosInstance.post(`${baseURL}verify`, body);
});

export const clientVerifyRegisterOTP = catchAsync(async (body: any) => {
  return await axiosInstance.post(`${clientURL}/otp-verification`, body);
});
